import { c as _c } from "react/compiler-runtime";
import { Accordion, HStack, Text } from '@chakra-ui/react';
import { PitchIssueView } from '@src/components/sco/PitchDeckAuditor/model/types';

/** The per-slide "Top Problems" accordion — one entry per audit `issue` item. */
export function SlideIssues(t0) {
  const $ = _c(4);
  const {
    issues
  } = t0;
  if (!issues.length) {
    return null;
  }
  let t1;
  if ($[0] !== issues) {
    t1 = issues.map(_temp);
    $[0] = issues;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <Accordion.Root collapsible={true} multiple={true} bgColor="colorPalette.card/25" borderRadius="md" variant="enclosed">{t1}</Accordion.Root>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(issue, idx) {
  const heading = issue.ruleTitle || issue.body;
  const showBody = issue.ruleTitle && issue.body && issue.ruleTitle !== issue.body;
  return <Accordion.Item key={issue.id} value={issue.id}><Accordion.ItemTrigger cursor="pointer" paddingY={2.5}><HStack flex={1} gap={0}><Text as="span" color="fg.muted" fontSize="sm" fontWeight="bold" mr={2}>{idx + 1}.</Text><Text fontSize="sm" fontWeight="semibold" lineClamp={1} textAlign="left">{heading}</Text></HStack><Accordion.ItemIndicator /></Accordion.ItemTrigger><Accordion.ItemContent><Accordion.ItemBody>{showBody && <Text color="fg.muted" fontSize="sm">{issue.body}</Text>}{issue.targetPhrase && <Text color="fg.subtle" fontSize="xs" mt={showBody ? 2 : 0}>Watch this phrase: “{issue.targetPhrase}”</Text>}</Accordion.ItemBody></Accordion.ItemContent></Accordion.Item>;
}